import {
  Box,
  Button,
  Image,
  Text,
  AccordionItem as ChakraAccordionItem,
  AccordionHeader,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/core"
import React from "react"

type AccordionItemProps = {
  title: string
  content: string
}
export const AccordionItem = ({ title, content }: AccordionItemProps) => (
  <ChakraAccordionItem mb={3}>
    <AccordionHeader
      bg="green.700"
      color="white"
      _hover={{ background: "green.800" }}
    >
      <Box flex="1" textAlign="left">
        {title}
      </Box>
      <AccordionIcon />
    </AccordionHeader>
    <AccordionPanel pb={4}>
      <Box className="html" dangerouslySetInnerHTML={{ __html: content }} />
    </AccordionPanel>
  </ChakraAccordionItem>
)
